import isNull from "lodash/isNull";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { bugNotif } from "../../api/bugsnag";
import { getErrorMsg } from "../../../Common/utils/common";

import useWLConfigStore from "./store";
import { getWlConfig } from "../../services/config";

export const useWLConfigProvider = () => {
  const [setWlConfig] = useWLConfigStore((state) => [state.setWlConfig]);

  const { data, error, isLoading } = useQuery({
    queryKey: ["WLCONFIG"],
    queryFn: async () => {
      const resp = await getWlConfig();
      return resp;
    },
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (!isNull(error)) {
      bugNotif(
        "useWLConfigProvider - getWLConfigProvider",
        getErrorMsg(error).rawErrorMsg
      );
    }
  }, [error]);

  useEffect(() => {
    if (!!data) {
      setWlConfig(data);
    }
  }, [data]);

  return { isLoading };
};
